import { useEffect, useState, useMemo } from 'react'
import useSignalRFeed from '../../hooks/useSignalrFeed'
import './Feed.scss'
import SpinnerIcon from '../Icons/SpinnerIcon'
import StoreEventFeedItem from '../../types/StoreEventFeedItem'
import { WebSocketInvocation } from '../../hooks/webSocketInvocation'
import filterAndSortFeedItems from './filterAndSortFeedItems'
import config from '../../config'
import { FeedColumn } from '../FeedColumn/FeedColumn'
import { useNavigate, useParams } from 'react-router-dom'
import SessionInfo from '../SessionInfo/SessionInfo'
import { IcaDialog } from '../IcaElements/IcaDialog'
import { IcaHeader } from '../IcaElements/IcaHeader'

export default function Feed() {
  const navigate = useNavigate()
  const { sessionId } = useParams()

  const [feed, setFeed] = useState<Array<StoreEventFeedItem>>([])

  const invocations = useMemo<Array<WebSocketInvocation<StoreEventFeedItem>>>(() => [
    {
      name: 'UpsertSessionState',
      action: (data: StoreEventFeedItem) => {
        setFeed((prevFeedState: Array<StoreEventFeedItem>) => {
          return filterAndSortFeedItems(prevFeedState, data)
        })
      }
    }
  ], [setFeed])

  const { initialFeed, loading } = useSignalRFeed<StoreEventFeedItem>(config.EVENT_FEED_SIGNALR_URL, `${config.EVENT_API_BASE_URL}/v1/storeevent`, invocations)
  
  useEffect(() => {
    setFeed(initialFeed)
  }, [initialFeed])
 
  const onSessionModalClose = () => {
    navigate('/live-feed')
  }

  const handleSessionFlagChanged = (sessionId: string, isFlagged: boolean, customerId: string) => {
    setFeed(prevFeed => prevFeed.map(session => 
      session.id === sessionId
        ? {
          ...session,
          isSessionFlagged: isFlagged,
          isCustomerFlagged: isFlagged || session.isCustomerFlagged
        } : {
          ...session,
          isCustomerFlagged: isFlagged && session.customerId === customerId ? true : session.isCustomerFlagged
        }
    ))
  }

  return (
    <>
      <div className="feed feed-table-body">
        {loading && <div className='feed-spinner'><SpinnerIcon /> </div>}
        <div className="feed-grid flex flex-col md:flex-row">
          <FeedColumn title={'Öppnat dörr'} items={feed.filter((item) => item.sessionState === 'Visiting')} />
          <FeedColumn title={'Handlar'} items={feed.filter((item) => item.sessionState === 'Shopping')} />
          <FeedColumn title={'Betalar'} items={feed.filter((item) => item.sessionState === 'Paying')} />
          <FeedColumn title={'Dörr ut'} items={feed.filter((item) => item.sessionState === 'Exiting')} />
        </div>
      </div>
      {sessionId &&
      <IcaDialog
        open={!!sessionId}
        onClose={onSessionModalClose}
        snaptotop
      >
        <IcaHeader
          slot='header'
          variant='dialog'
          heading='Kundvarv'
          leftaction='close'
          onLeftactionclick={onSessionModalClose}
        />
        <SessionInfo onSessionFlagChanged={(sessionId, isFlagged, customerId) => handleSessionFlagChanged(sessionId, isFlagged, customerId)} />
      </IcaDialog>
      }
    </>
  )
}

